import { atom } from 'recoil';

export interface GeolocationState {
  latitude: number | null;
  longitude: number | null;
  accuracy: number | null;
  altitude: number | null;
  altitudeAccuracy: number | null;
  heading: number | null;
  speed: number | null;
  timestamp: number | null;
  error: {
    code: number;
    message: string;
  } | null;
  isLoading: boolean;
}

export const atom_geolocationState = atom<GeolocationState>({
  key: 'Geolocation',
  default: {
    latitude: null,
    longitude: null,
    accuracy: null,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null,
    timestamp: null,
    error: null,
    isLoading: true,
  },
});
